export default "__VITE_ASSET__Dn6vsaRu__"